// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-view-container {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
.tree-view-container::-webkit-scrollbar {
  display: unset;
  margin: 1px;
  width: 3px;
  height: 8px;
}
.tree-view-container::-webkit-scrollbar-track {
  background-color: lightgrey;
  border-radius: 5px;
  margin: 4px;
}
.tree-view-container::-webkit-scrollbar-thumb {
  background-color: grey;
  border-radius: 5px;
}
.tree-view-container::-webkit-scrollbar-thumb:hover {
  background-color: darkgrey;
}

.tree-item-container {
  width: 100%;
  position: relative;
}

.MuiTreeItem-root {
  width: 100%;
  align-self: center;
}

.MuiTreeItem-content {
  padding: 5px 8px !important;
  width: auto !important;
}

.MuiTreeItem-label {
  display: flex;
  align-items: center;
}

.muiTreeItem-label-justified {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.MuiFormControlLabel-root.tree-view-switch {
  display: inline-flex;
  flex-direction: row-reverse;
  margin-right: 0;
  margin-left: 10px;
}

.tree-item-title-disabled {
  color: #cccccc;
}

.MuiTreeItem-iconContainer .MuiSvgIcon-root {
  font-size: 25px !important;
}

.MuiCollapse-root {
  margin-left: 30px;
}

.node-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./res/stylesheets/systemTreeComponent.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AAAI;EACI,cAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAER;AACI;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;AACR;AACI;EACI,sBAAA;EACA,kBAAA;AACR;AACI;EACI,0BAAA;AACR;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,2BAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAII;EACI,0BAAA;AADR;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFJ","sourcesContent":[".tree-view-container {\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100%;\n    &::-webkit-scrollbar {\n        display: unset;\n        margin: 1px;\n        width: 3px;\n        height: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background-color: lightgrey;\n        border-radius: 5px;\n        margin: 4px;\n    }\n    &::-webkit-scrollbar-thumb {\n        background-color: grey;\n        border-radius: 5px;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n        background-color: darkgrey;\n    }\n}\n\n.tree-item-container {\n    width: 100%;\n    position: relative;\n}\n\n.MuiTreeItem-root {\n    width: 100%;\n    align-self: center;\n}\n\n.MuiTreeItem-content {\n    padding: 5px 8px !important;\n    width: auto !important;\n}\n\n.MuiTreeItem-label {\n    display: flex;\n    align-items: center;\n}\n\n.muiTreeItem-label-justified {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.MuiFormControlLabel-root.tree-view-switch {\n    display: inline-flex;\n    flex-direction: row-reverse;\n    margin-right: 0;\n    margin-left: 10px;\n}\n\n.tree-item-title-disabled {\n    color: lighten(black, 80%);\n}\n\n.MuiTreeItem-iconContainer {\n    .MuiSvgIcon-root {\n        font-size: 25px !important;\n    }\n}\n\n.MuiCollapse-root {\n    margin-left: 30px;\n}\n\n.node-title {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
